import React, { useState, useRef, useEffect } from 'react';

// Componentes.
import {
  Button,
  TextField,
  Grid,
  Stack,
  Typography,
  Box,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

// Iconos
import AddchartIcon from '@mui/icons-material/Addchart';
//
import msgNotificacion from '../../scripts/notification';
import SeguridadService from '../../services/seguridadService';
import { CustomStyles } from '../styles/ModalStyles';

const ModalMenu = ({ setOpenModal, openModal, setNoChanges, dataMenu, isEdit, isMenu }) => {
  const inputEls = useRef([])
  const [isHidden, setIsHidden] = useState(false)
  const [menuSelected, setMenuSelected] = useState('')
  const [dataMenuPadre, setDataMenuPadre] = useState([])
  const [values, setValues] = useState({
    menu: '',
    url: '',
    icono: '',
  })

  const handleClose = () => {
    limpiar()
    setOpenModal(false)
  }

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    })
  }

  const handleSelectChange = (event) => {
    try {
      setMenuSelected(event.target.value)
    } catch (error) {
      console.error(error)
    }
  }

  const limpiar = () => {
    setValues({
      ...values,
      menu: '',
      url: '',
      icono: '',
    })
  }

  const getMenuPadre = async () => {
    try {
      SeguridadService.getMenuPadre()
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')            
            return
          }

          if (response.Codigo === 1) {
            setDataMenuPadre(response.Data)
          } else {
            setDataMenuPadre([])
            msgNotificacion(response.Mensaje, 'info')
          }
      })
      .catch((error) => {        
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const guardarCambios = () => {
    try {
      const data = {
        codMenu: dataMenu?.IdMenu,
        codPadre: !menuSelected ? 0 : parseInt(menuSelected),
        menu: values.menu,
        urlPath: values.url,
        icono: values.icono,
        isMenu: isMenu,
        isEdit: isEdit
      }
      
      if (!isMenu) {
        if (data.codPadre <= 0) {
          msgNotificacion('Seleccione el Menú asociado', 'warning')
          return
        }
      }
  
      if (!data.menu) {
        msgNotificacion('Escriba el nombre del menú', 'warning')
        inputEls.current['menu'].focus()
        return
      }
      
      if (!isMenu) {
        if (!data.urlPath) {
          msgNotificacion('Escriba la URL de acceso', 'warning')
          inputEls.current['url'].focus()
          return
        }    
      }

      if (!data.icono) {
        msgNotificacion('Escriba el ícono del menú', 'warning')
        inputEls.current['icono'].focus()
        return
      }

      //console.log(data)
  
      SeguridadService.procesarMenu(data)
        .then((response) => {
  
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            msgNotificacion(response.Mensaje, 'success')
            limpiar()
            setNoChanges(false)
            setOpenModal(false)
          } else {
            msgNotificacion(response.Mensaje, 'warning')
            setNoChanges(true)
          }
        })
        .catch((error) => {
          console.log('Error:', error.message)
        })      
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (openModal) {      
      getMenuPadre()
            
      if (isEdit) {
        setValues({
          ...values,          
          menu: dataMenu?.Menu,
          url: dataMenu?.UrlPath,
          icono: dataMenu?.Icono,
        })

        //setMenuCustomSelected({ Id: dataMenu?.IdPadre })
        setIsHidden(true)
      } else {
        if (isMenu)        
          setIsHidden(true)
        else setIsHidden(false)
      }
    }  
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal])

  return (
    <div>
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slotProps={{
          backdrop: {
            timeout: 1000
          }
        }}
        >
        <Box sx={CustomStyles}>
          <Typography id="modal-modal-title" className='mb-4' textAlign={'center'} variant="h4" component="h2">
            {!isEdit ? `Crear nuevo ${isMenu ? 'menú' : 'sub-menú'}` : `Editando ${dataMenu?.IsSubMenu ? 'sub-menú' : 'menú'}` }
            <AddchartIcon style={{ fontSize: '1.1em', marginLeft: '10px' }} />
            
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12} md={12} className='mt-2' hidden={isHidden}>
              <FormControl fullWidth size='small'>
                <InputLabel id='RolesLabel' className='text-transform-none'>
                  Menú Padre
                </InputLabel>
                <Select
                  id='cboMenuPadre'
                  name='menuSelected'
                  label='Menú padre'
                  value={menuSelected}
                  onChange={handleSelectChange}
                  fullWidth
                  size='small'
                  className='text-start'
                  displayEmpty
                  inputRef={(el) => (inputEls.current['menuSelected'] = el)}
                >
                  {
                    dataMenuPadre?.map((item) => {
                      return (
                        <MenuItem key={item.Id} value={item.Id}>{item.Nombre}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={12} className='mt-2'>
              <TextField
                id='txtMenu'
                name='menu'
                variant='outlined'
                label='Nombre del menú'
                placeholder='Nombre del menú'
                size='small'
                value={values.menu}                
                inputRef={(el) => (inputEls.current['menu'] = el)}
                fullWidth
                onChange={handleChange}
                InputLabelProps={{                
                  className: 'LabelMui'
                }}          
              />
            </Grid>

            <Grid item xs={12} md={12} className='mt-2'>
              <TextField
                id='txtUrl'
                name='url'
                variant='outlined'
                label='URL de acceso'
                placeholder='Escriba la URL'
                size='small'
                value={values.url}
                inputRef={(el) => (inputEls.current['url'] = el)}
                fullWidth
                onChange={handleChange}
                InputLabelProps={{
                  className: 'LabelMui'
                }}          
              />
            </Grid>
            
            <Grid item xs={12} md={12} className='mt-2'>
              <TextField
                id='txtIcono'
                name='icono'
                variant='outlined'
                label='Icono'
                placeholder='Digite el ícono'
                size='small'
                value={values.icono}
                inputRef={(el) => (inputEls.current['correo'] = el)}
                fullWidth
                onChange={handleChange}
                InputLabelProps={{
                  className: 'LabelMui'
                }}          
              />
            </Grid>

          </Grid>          
      
          <Stack spacing={2} direction="row-reverse" marginTop={2}>
            <Button variant="contained" className='text-transform-none' onClick={guardarCambios}>
              Guardar cambios
            </Button>
            <Button variant="outlined" className='text-transform-none' onClick={handleClose}>
              Cancelar
            </Button>
          </Stack>
        </Box>
      </Modal>    
    </div>
  ) 
}

export default ModalMenu;